import type { inferParserType, Parser } from './parser';

export type RouteDefinition<
  Name extends string = string,
  Path extends string = string,
  ParsePath extends Record<string, Parser<any>> = Record<string, Parser<any>>,
  ParseHash extends Record<string, Parser<any>> = Record<string, Parser<any>>,
  ParseSearch extends Record<string, Parser<any>> = Record<string, Parser<any>>,
> = {
  name: Name;
  path: Path;
  parsePath: ParsePath;
  hashes: ParseHash;
  parseSearch: ParseSearch;
};

export type AnyRouteProps = RouteProps<any, any, any, any, any>;
export type RouteProps<
  Name extends string = string,
  Path extends string = string,
  ParsePath extends Record<string, Parser<any>> = Record<string, Parser<any>>,
  ParseHash extends Record<string, Parser<any>> = Record<string, Parser<any>>,
  ParseSearch extends Record<string, Parser<any>> = Record<string, Parser<any>>,
> = {
  def: RouteDefinition<Name, Path, ParsePath, ParseHash, ParseSearch>;
  path: { [K in keyof ParsePath]: inferParserType<ParsePath[K]> };
  hash: { [K in keyof ParseHash]: inferParserType<ParseHash[K]> };
  search: { [K in keyof ParseSearch]: inferParserType<ParseSearch[K]> };
};

export function defineRoute<
  Name extends string = string,
  Path extends string = string,
  ParsePath extends Record<string, Parser<any>> = Record<string, Parser<any>>,
  ParseHash extends Record<string, Parser<any>> = Record<string, Parser<any>>,
  ParseSearch extends Record<string, Parser<any>> = Record<string, Parser<any>>,
>(name: Name, def: {
  path: Path;
  parsePath: ParsePath;
  hashes: ParseHash;
  parseSearch: ParseSearch;
}): RouteDefinition<
  Name,
  Path,
  ParsePath,
  ParseHash,
  ParseSearch
> {
  return {
    name,
    ...def,
  };
}
